<span class="message-types">
	@for (icon of MessageTypeIcons; track icon) {
		<fa-icon
			[icon]="icon.icon"
			[ngClass]="{
				active: messageType() === icon.type,
				hidden:
					(icon.adminOnly && config.app !== ClientName.TM_ADMIN) ||
					icon.type === MessageTypes.MessagesReset ||
					icon.type === MessageTypes.CompletionDate ||
					icon.type === MessageTypes.CaseWorker ||
					icon.type === MessageTypes.Coupon,
				warning: icon.type === MessageTypes.Warning,
				problem: icon.type === MessageTypes.Problem
			}"
			(click)="newType = icon.type"
			[title]="MessageTypes[icon.type] | translate"
			transform="{{ messageType() === icon.type ? 'grow-7' : null }}"
		>
		</fa-icon>
	}
</span>
